// PROBĚHLÉ (již neaktivní) kurzy, které jsme realizovali.
// Bez konkrétních dat. up: true = proběhlo v rámci programu „Jsem v kurzu" (Úřad práce).
export const archiveCourses = [
  { title: "Moderní nástroje umělé inteligence (AI) v profesní praxi", up: true },
  { title: "Moderní nástroje umělé inteligence (AI) v profesní praxi – online", up: true },
  { title: "Umělá inteligence (AI) pro obchodníky – online", up: true },
  { title: "Transformace pracovních procesů pomocí AI", up: true },
  { title: "Umělá inteligence pro pedagogy", up: false },
  { title: "Umělá inteligence pro soudní znalce", up: false },
  { title: "AI pro účetní a daňové poradce", up: false },
  { title: "Digitální restart pro maminky po mateřské", up: false },
];
